import { Anchor, Box, CheckBox, FileInput, FormField, Grid, ResponsiveContext, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import AutoSizeTextArea from "../components/AutoSizeTextArea";
import Flag from "../components/Flag";
import { ImagePicker } from "../components/ImagePicker";
import ThemeBuilder from "../components/ThemeBuilder";
import GameLogoPicker from "./GameLogoPicker";
import GameSplashPicker from "./GameSplashPicker";
import { githubLight, githubDark } from "@uiw/codemirror-theme-github";
import { autocompletion, CompletionContext } from "@codemirror/autocomplete";

const GameDetails = ({ game, isBusy, onChange }) => {
    const [name, setName] = React.useState(game.name || "");
    const [logoUri, setLogoUri] = React.useState(game.logoUri || "");
    const [splashUri, setSplashUri] = React.useState(game.splashUri || "");
    const [description, setDescription] = React.useState(game.description || "");
    const [about, setAbout] = React.useState(game.about || "");
    const [isPublic, setIsPublic] = React.useState(game.isPublic || false);

    const [logoContent, setLogoContent] = React.useState("");
    const [splashContent, setSplashContent] = React.useState("");

    const [gameFileExt, setGameFileExt] = React.useState("");

    React.useEffect(() => {
        onChange({ description, name, logoUri, logoContent, splashUri, splashContent, about, isPublic, gameFileExt });
    }, [description, name, logoUri, logoContent, splashUri, splashContent, about, isPublic, gameFileExt]);

    const size = React.useContext(ResponsiveContext);

    React.useEffect(() => {
        if (game.logoUri && logoUri != game.logoUri) {
            setLogoUri(game.logoUri);
        }
        if (game.splashUri && splashUri != game.splashUri) {
            setSplashUri(game.splashUri);
        }
    }, [game.logoUri, game.splashUri]);

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    const handleSplashChange = ({ uri, content }) => {
        if (content) {
            setSplashContent(content);
            setSplashUri("");
        } else if (uri) {
            setSplashUri(uri);
            setSplashContent("");
        }
    };

    return (
        <div>
            <>
                <Grid columns={["auto"]} gap="small">
                    <CheckBox label="Public" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isBusy} />

                    <FormField label="Game Name">
                        <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                    </FormField>

                    <FormField label="Description">
                        <AutoSizeTextArea value={description} onChange={(e) => setDescription(e.target.value)} disabled={isBusy} />
                    </FormField>

                    <FormField label="About">
                        <CodeMirror value={about} onChange={(e) => setAbout(e)} extensions={[autocompletion({ override: [myCompletions] })]} theme={isDarkMode ? githubDark : githubLight} />
                        {/* <MDEditor value={about} onChange={(e) => setAbout(e)} /> */}
                    </FormField>

                    <Box fill={true}>
                        <GameLogoPicker uri={logoUri} disabled={isBusy} onSelect={handleLogoChange}></GameLogoPicker>
                    </Box>
                    <Box fill={true}>
                        <GameSplashPicker uri={splashUri} disabled={isBusy} onSelect={handleSplashChange}></GameSplashPicker>
                    </Box>
                </Grid>
            </>
        </div>
    );
};

export default GameDetails;
